import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { lockScroll, unlockScroll } from "@/lib/scrollLock";

const Modal = ({ open, onClose, title, children, testId }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    lockScroll();
    return () => unlockScroll();
  }, [open]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    const handleCancel = (e) => {
      e.preventDefault();
      onClose();
    };
    const handleClick = (e) => {
      if (e.target === dialog) onClose();
    };
    dialog.addEventListener("cancel", handleCancel);
    dialog.addEventListener("click", handleClick);
    return () => {
      dialog.removeEventListener("cancel", handleCancel);
      dialog.removeEventListener("click", handleClick);
    };
  }, [onClose]);

  return (
    <dialog
      ref={dialogRef}
      data-testid={testId}
      className="backdrop:bg-ink/70 rounded-2xl bg-cream p-0 m-auto max-w-2xl w-[calc(100%-2rem)] max-h-[85vh]"
    >
      <div className="relative p-6 md:p-8 overflow-y-auto max-h-[85vh]">
        <button
          type="button"
          data-testid={testId ? `${testId}-close` : undefined}
          onClick={onClose}
          aria-label="Close"
          className="sticky top-0 float-right -mt-2 -mr-2 flex items-center justify-center w-9 h-9 rounded-full border border-linen bg-cream text-ink hover:border-terracotta hover:text-terracotta transition-colors duration-200"
        >
          <X className="h-4 w-4" />
        </button>
        <h2 className="font-display text-2xl md:text-3xl tracking-tight pr-6">{title}</h2>
        <div className="mt-6 clear-both">{children}</div>
      </div>
    </dialog>
  );
};

export default Modal;
